import { render, staticRenderFns } from "./materialswappable-menu.vue?vue&type=template&id=ff22269c&"
import script from "./materialswappable-menu.vue?vue&type=script&lang=js&"
export * from "./materialswappable-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VSheet})
